import { render, staticRenderFns } from "./VerificationEmailCard.vue?vue&type=template&id=93887934&scoped=true&"
import script from "./VerificationEmailCard.vue?vue&type=script&lang=js&"
export * from "./VerificationEmailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93887934",
  null
  
)

export default component.exports